import { type App, inject, ref, type Ref } from 'vue'
import type { Router } from 'vue-router'
import type { ReadonlyRef } from '@/helpers'

const key = 'app.plugin.current-url'
const initialUrlKey = 'app.plugin.initial-url'

export function installCurrentUrl(
    app: App,
    router: Router,
    initialUrl: URL
): Ref<URL> {
    const host = initialUrl.host
    const protocol = initialUrl.protocol
    const url = ref(initialUrl)

    router.beforeEach((to) => {
        url.value = new URL(`${protocol}//${host}${to.fullPath}`)
    })

    app.provide(key, url)
    app.provide(initialUrlKey, initialUrl)

    return url
}

export function useCurrentUrl(): ReadonlyRef<URL> {
    return inject(key) as ReadonlyRef<URL>
}

export function useHost(): string {
    return useCurrentUrl().value.host
}

export function useScheme(): string {
    return useCurrentUrl().value.protocol
}

export function useInitialUrl(): URL {
    return inject(initialUrlKey) as URL
}
